export enum QueryKeys {
  PRODUCT_DATA = 'productData',
  FORM_DATA = 'formData',
  USER_DATA = 'userData',
  SAVED_TEXT_LIST = 'savedTextList',
  ONBOARDING_TOOLTIPS = 'onboardingTooltips',
  SPLIT_DATA = 'splitData',
  PACKAGES = 'packages',
  PACKAGE_PURCHASE = 'packagePurchase',
  PACKAGE_CHECKOUT = 'packageCheckout',
  POPUPS = 'popups',
  TOASTS = 'toasts',
  PASSWORD_CAPTCHA = 'passwordCaptcha',
  SUBSCRIPTION_INFO = 'subscriptionInfo',
  AI_TOOLS_ACCESS_V2 = 'aiToolsAccessV2',
  SITE_INFO = 'siteInfo',
  SIDEBAR_DRAWER = 'sidebarDrawer',
  AI_HISTORY_BADGE = 'aiHistoryBadge',
  USER_PACKAGE = 'userPackage',
  WORDS_PACKAGES = 'wordsPackages',
  WORDS_BALANCE_ANIMATION = 'wordsBalanceAnimation',
  TESTING_DATA = 'testingData',
}
